import { render } from "./FaqsWrapper.vue?vue&type=template&id=15d22357&scoped=true"
import script from "./FaqsWrapper.vue?vue&type=script&lang=js"
export * from "./FaqsWrapper.vue?vue&type=script&lang=js"

import "./FaqsWrapper.vue?vue&type=style&index=0&id=15d22357&scoped=true&lang=css"

import exportComponent from "C:\\4 Websites\\enfinity\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d22357"]])

export default __exports__